<template>
  <div />
</template>

<script>
import classes from '~/config/classes'

/**
 * Vue: Venn single media (venn-single-media)
 * -----------------------------------------------------------------------------
 * Single media component for Venn apps.
 * - Static section.
 *
 */

const selectors = {
  videoPlayer: '[js-venn-single-media="video-player"]',
  videoControls: '[js-venn-single-media="video-controls"]',
  videoPause: '[js-venn-single-media="video-pause"]',
  videoPlay: '[js-venn-single-media="video-play"]',
  videoButtons: '[js-venn-single-media="video-buttons"]',
  videoMute: '[js-venn-single-media="video-mute"]',
  videoUnmute: '[js-venn-single-media="video-unmute"]',
  videoProgressBackground: '[js-venn-single-media="video-progress-background"]',
  videoProgressOuter: '[js-venn-single-media="video-progress-outer"]',
}

export default {
  name: 'VennSingleMedia',

  data() {
    return {
      videoPlayer: [...document.querySelectorAll(selectors.videoPlayer)],
      videoControls: [...document.querySelectorAll(selectors.videoControls)],
      videoPause: [...document.querySelectorAll(selectors.videoPause)],
      videoPlay: [...document.querySelectorAll(selectors.videoPlay)],
      videoButtons: [...document.querySelectorAll(selectors.videoButtons)],
      videoMute: [...document.querySelectorAll(selectors.videoMute)],
      videoUnmute: [...document.querySelectorAll(selectors.videoUnmute)],
      videoProgressBackground: [...document.querySelectorAll(selectors.videoProgressBackground)],
      videoProgressOuter: [...document.querySelectorAll(selectors.videoProgressOuter)],
    }
  },

  mounted() {
    this.setEventListeners()
  },

  methods: {

    /**
     * Event listeners for video controls.
     */
    setEventListeners() {
      this.videoPlayer.forEach((element, index) => {
        const videoControls = element.hasAttribute('data-control')

        if (videoControls) {
          this.videoMute[index]
            .addEventListener('click', () => this.toggleMute(true, index))

          this.videoUnmute[index]
            .addEventListener('click', () => this.toggleMute(false, index))

          element
            .addEventListener('timeupdate', () => this.setVideoProgress(element, index))
        }

        this.videoPause[index]
          .addEventListener('click', () => this.toggleVideo(false, index))
        this.videoPlay[index]
          .addEventListener('click', () => this.toggleVideo(true, index))
      })
    },

    /**
     * Toggle video play/pause status
     */
    toggleVideo(videoStatus, index) {
      if (videoStatus) {
        this.videoButtons[index].style.opacity = '0'
        this.videoPlay[index].classList.add(classes.hidden)

        this.videoPlayer[index].play()

        this.videoPause[index].classList.remove(classes.hidden)
      } else if (videoStatus === false) {
        this.videoPause[index].classList.add(classes.hidden)

        this.videoPlayer[index].pause()

        this.videoPlay[index].classList.remove(classes.hidden)
        this.videoButtons[index].style.opacity = '1'
      }
    },

    /**
     * Toggle video mute status
     */
    toggleMute(muteStatus, index) {
      if (muteStatus) {
        this.videoMute[index].classList.add(classes.hidden)

        this.videoPlayer[index].muted = true

        this.videoUnmute[index].classList.remove(classes.hidden)
      } else if (!muteStatus) {
        this.videoUnmute[index].classList.add(classes.hidden)

        this.videoPlayer[index].muted = false

        this.videoMute[index].classList.remove(classes.hidden)
      }
    },

    /**
     * Control video progress bar by calculating
     * current video playback time
     */
    setVideoProgress(element, index) {
      const currentTime = element.currentTime
      const duration = element.duration

      const progress = (100 * currentTime) / duration

      this.videoProgressOuter[index].style.width = `${progress}%`

      if (currentTime === duration) {
        this.toggleVideo(false, index)
      }
    },
  },

}
</script>

<style lang="scss">
@import './venn-single-media';
</style>
